import script from "./MigratePoolsInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./MigratePoolsInfo.vue?vue&type=script&setup=true&lang=ts"

import "./MigratePoolsInfo.vue?vue&type=style&index=0&id=a476b918&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a476b918"]])

export default __exports__